"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RestProxyError extends Error {
    constructor(response) {
        super();
        this.status = response.status;
        this.statusText = response.statusText;
        this.message = `Error communicating with REST Proxy: ${this.statusText} [${this.status}]`;
    }
}
exports.default = RestProxyError;
//# sourceMappingURL=RestProxyError.js.map